import { Tabs } from '@mantine/core';
import { IconChartFunnel, IconStars, IconTable, IconUsersGroup } from '@tabler/icons-react';
import queryString from 'query-string';
import { useLocation, useNavigate } from 'react-router';

import Metadata from '../../../components/Metadata';
import { CustomerInsightsTabs, Page } from '../../../constants/pageTitles';
import AudiencePerformanceTab from './AudiencePerformanceTab';
import CohortAnalysisTab from './CohortAnalysisTab';
import FunnelsTab from './FunnelsTab';
import RfmAnalysisTab from './RfmAnalysisTab';

const defaultMainTab = 'rfm';

const CustomerInsightsPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const search = queryString.parse(location.search);
  // Fall back rather than trust the query param: an unknown value would leave
  // the page with no visible panel and "undefined" in the document title.
  // `Object.hasOwn` (rather than a truthy lookup) keeps inherited
  // Object.prototype keys like "constructor" from passing the guard.
  const mainTab = Object.hasOwn(CustomerInsightsTabs, search.mainTab) ? search.mainTab : defaultMainTab;

  const setMainTab = (mainTab) => {
    navigate(
      `${location.pathname}?${queryString.stringify({
        ...search,
        mainTab,
      })}`
    );
  };

  return (
    <div>
      <Metadata title={`${Page['customerInsights']} | ${CustomerInsightsTabs[mainTab]}`} />
      <Tabs value={mainTab} onChange={setMainTab} mb={0} keepMounted={false} mt="md">
        <Tabs.List>
          <Tabs.Tab value="rfm" leftSection={<IconUsersGroup size={16} />}>
            {CustomerInsightsTabs.rfm}
          </Tabs.Tab>
          <Tabs.Tab value="audiencePerformance" leftSection={<IconStars size={16} />}>
            {CustomerInsightsTabs.audiencePerformance}
          </Tabs.Tab>
          <Tabs.Tab value="funnels" leftSection={<IconChartFunnel size={16} />}>
            {CustomerInsightsTabs.funnels}
          </Tabs.Tab>
          <Tabs.Tab value="cohorts" leftSection={<IconTable size={16} />}>
            {CustomerInsightsTabs.cohorts}
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="rfm">
          <RfmAnalysisTab />
        </Tabs.Panel>

        <Tabs.Panel value="audiencePerformance">
          <AudiencePerformanceTab />
        </Tabs.Panel>

        <Tabs.Panel value="funnels">
          <FunnelsTab />
        </Tabs.Panel>

        <Tabs.Panel value="cohorts">
          <CohortAnalysisTab />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

export default CustomerInsightsPage;
